import { Button, Group, Text } from '@mantine/core';

type Props = {
  saving: boolean;
  onDiscard: () => void;
};

export function FormSaveBar({ saving, onDiscard }: Props) {
  return (
    <Group
      justify="space-between"
      py="xs"
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        background: 'var(--mantine-color-body)',
        borderTop: '1px solid var(--mantine-color-default-border)',
      }}
    >
      <Text size="xs" c="dimmed">
        Unsaved changes
      </Text>
      <Group gap="xs">
        <Button
          size="xs"
          variant="default"
          onClick={onDiscard}
          disabled={saving}
        >
          Discard
        </Button>
        <Button size="xs" type="submit" loading={saving}>
          Save
        </Button>
      </Group>
    </Group>
  );
}
